import Image from "next/image";

export type CheckIconProps = {
  correct: boolean;
};

const CheckIcon = ({ correct }: CheckIconProps) => {
  return (
    <>
      {correct ? (
        <Image
          alt="valid-check-icon"
          src="/static/pages/affiliatePage/green-check.svg"
          width={24}
          height={24}
        />
      ) : (
        <Image
          alt="not-valid-check-icon"
          src="/static/pages/affiliatePage/grey-check.svg"
          width={24}
          height={24}
        />
      )}
    </>
  );
};

export default CheckIcon;
